// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useAuth } from '../../context/AuthContext';
// import subscriptionEnforcement from '../../services/subscriptionEnforcement';
// import { Package, TrendingUp, Users, Warehouse } from 'lucide-react';
// import './Login.css';

// function Login() {
//   const [username, setUsername] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState('');
//   const [isSubscriptionError, setIsSubscriptionError] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const { login } = useAuth();
//   const navigate = useNavigate();

//   async function handleSubmit(e) {
//     e.preventDefault();
//     setError('');
//     setIsSubscriptionError(false);
//     setLoading(true);

//     try {
//       // 1. Login first
//       const result = await login(username, password);

//       if (!result.success) {
//         const errorMsg = result.error || 'Login failed. Please check your credentials.';
//         setError(errorMsg);
//         setLoading(false);
//         return;
//       }

//       // Wait a moment for subscription sync to complete
//       await new Promise(resolve => setTimeout(resolve, 1000));

//       const accessStatus = await subscriptionEnforcement.checkAccess();

//       // 3. ⭐ Redirect based on subscription status
//       if (!accessStatus.allowed) {
//         // No subscription or hard locked
//         setError('No active subscription found. Please subscribe to continue.');
//         setIsSubscriptionError(true);

//         localStorage.setItem('subscription_expired', 'true');

//         setTimeout(() => {
//           navigate('/subscribe');
//         }, 1500);

//       } else if (accessStatus.requiresSync) {
//         // Needs to connect online to verify
//         setError('Please stay online to verify your subscription.');
//         setIsSubscriptionError(true);

//       } else if (accessStatus.daysRemaining !== undefined && accessStatus.daysRemaining > 0) {
//         // ⭐ VALID SUBSCRIPTION with days remaining
//         localStorage.removeItem('subscription_expired');
//         navigate('/dashboard');

//       } else if (accessStatus.daysExpired && accessStatus.daysExpired > 0) {
//         // ⭐ EXPIRED - check grace period
//         const daysExpired = accessStatus.daysExpired;

//         if (daysExpired <= 7) {
//           // Grace period - allow access with warning
//           localStorage.setItem('subscription_expired', 'true');
//           navigate('/dashboard');
//         } else if (daysExpired <= 30) {
//           // Read-only mode
//           localStorage.setItem('subscription_expired', 'true');
//           navigate('/dashboard');
//         } else {
//           // Hard lockout
//           setError(`Subscription expired ${daysExpired} days ago. Please renew to continue.`);
//           setIsSubscriptionError(true);
//           localStorage.setItem('subscription_expired', 'true');

//           setTimeout(() => {
//             navigate('/subscribe');
//           }, 1500);
//         }
//       } else {
//         // ⭐ DEFAULT: Valid subscription (allowed=true, no expiration)
//         localStorage.removeItem('subscription_expired');
//         navigate('/dashboard');
//       }

//     } catch (error) {
//       setError('An error occurred during login. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   }

//   const handleRenewClick = () => {
//     navigate('/subscribe');
//   };

//   return (
//     <div className="login-container">
//       {/* Left Side - Branding */}
//       <div className="login-left">
//         <div className="login-branding">
//           <h1 className="brand-title">TaalumaERP</h1>
//           <p className="brand-subtitle">Inventory Management for African Businesses</p>

//           <div className="features-grid">
//             <div className="feature-item">
//               <Package size={24} />
//               <span>Smart Inventory</span>
//             </div>
//             <div className="feature-item">
//               <TrendingUp size={24} />
//               <span>Sales Analytics</span>
//             </div>
//             <div className="feature-item">
//               <Users size={24} />
//               <span>Team Management</span>
//             </div>
//             <div className="feature-item">
//               <Warehouse size={24} />
//               <span>Multi-Warehouse</span>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Right Side - Login Form */}
//       <div className="login-right">
//         <div className="login-form-container">
//           <div className="login-header">
//             <h2>Welcome Back</h2>
//             <p>Sign in to continue to your dashboard</p>
//           </div>

//           <form onSubmit={handleSubmit} className="login-form">
//             <div className="form-group">
//               <label htmlFor="username">Username</label>
//               <input
//                 type="text"
//                 id="username"
//                 value={username}
//                 onChange={(e) => setUsername(e.target.value)}
//                 placeholder="Enter your username"
//                 required
//                 autoFocus
//                 disabled={loading}
//               />
//             </div>

//             <div className="form-group">
//               <label htmlFor="password">Password</label>
//               <input
//                 type="password"
//                 id="password"
//                 value={password}
//                 onChange={(e) => setPassword(e.target.value)}
//                 placeholder="Enter your password"
//                 required
//                 disabled={loading}
//               />
//             </div>

//             {error && (
//               <div className={`error-message ${isSubscriptionError ? 'subscription-error' : ''}`}>
//                 <div>⚠️ {error}</div>
//                 {isSubscriptionError && (
//                   <button
//                     type="button"
//                     onClick={handleRenewClick}
//                     className="btn-subscribe-redirect"
//                   >
//                     Renew Subscription →
//                   </button>
//                 )}
//               </div>
//             )}

//             <button type="submit" className="btn-login" disabled={loading}>
//               {loading ? 'Signing in...' : 'Sign In'}
//             </button>

//             <button
//               type="button"
//               onClick={() => navigate('/')}
//               className="btn-landing"
//             >
//               ← Back to Home
//             </button>
//           </form>

//           <div className="login-footer">
//             <span className="offline-indicator">
//               {navigator.onLine ? '🟢 Online' : '🔴 Offline'}
//             </span>
//             <span className="version">v{process.env.REACT_APP_VERSION || '1.0.0'}</span>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Login;



import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import subscriptionEnforcement from '../../services/subscriptionEnforcement';
import { Package, TrendingUp, Users, Warehouse } from 'lucide-react';
import './Login.css';

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubscriptionError, setIsSubscriptionError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');

  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
    localStorage.setItem('theme', theme);
  }, [theme]);

  const toggleTheme = () => setTheme(t => t === 'dark' ? 'light' : 'dark');

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setIsSubscriptionError(false); setLoading(true);
    try {
      const result = await login(username, password);
      if (!result.success) {
        setError(result.error || 'Login failed. Please check your credentials.');
        setLoading(false); return;
      }
      await new Promise(r => setTimeout(r, 1000));
      const access = await subscriptionEnforcement.checkAccess();
      if (!access.allowed) {
        setError('No active subscription found. Please subscribe to continue.');
        setIsSubscriptionError(true);
        localStorage.setItem('subscription_expired', 'true');
        setTimeout(() => navigate('/subscribe'), 1500);
      } else if (access.requiresSync) {
        setError('Please stay online to verify your subscription.');
        setIsSubscriptionError(true);
      } else if (access.daysExpired && access.daysExpired > 30) {
        setError(`Subscription expired ${access.daysExpired} days ago. Please renew.`);
        setIsSubscriptionError(true);
        setTimeout(() => navigate('/subscribe'), 1500);
      } else {
        localStorage.removeItem('subscription_expired');
        navigate('/dashboard');
      }
    } catch {
      setError('An error occurred. Please try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="lp-login" data-theme={theme}>
      <button className="lp-login__theme-toggle" onClick={toggleTheme} title="Toggle theme">
        {theme === 'dark' ? '☀️' : '🌙'}
      </button>

      {/* Left branding panel */}
      <div className="lp-login__left">
        <div className="lp-login__left-grid"></div>
        <div className="lp-login__left-glow"></div>
        <div className="lp-login__brand">
          <span className="lp-login__logo">⬡</span>
          <h1 className="lp-login__brand-name">TaalumaERP</h1>
          <p className="lp-login__brand-sub">Inventory management that works<br />with or without internet.</p>
          <div className="lp-login__features">
            {[
              { icon: <Package size={20} />, label: 'Smart Inventory' },
              { icon: <TrendingUp size={20} />, label: 'Sales Analytics' },
              { icon: <Users size={20} />, label: 'Team Management' },
              { icon: <Warehouse size={20} />, label: 'Multi-Warehouse' },
            ].map((f, i) => (
              <div key={i} className="lp-login__feature">
                <div className="lp-login__feature-icon">{f.icon}</div>
                <span>{f.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Right form panel */}
      <div className="lp-login__right">
        <div className="lp-login__form-wrap">
          <div className="lp-login__head">
            <h2>Welcome Back</h2>
            <p>Sign in to continue to your dashboard</p>
          </div>

          <form onSubmit={handleSubmit} className="lp-login__form">
            <div className="lp-form-group">
              <label htmlFor="username">Username</label>
              <input
                id="username" type="text"
                value={username} onChange={e => setUsername(e.target.value)}
                placeholder="Enter your username"
                required autoFocus disabled={loading}
              />
            </div>
            <div className="lp-form-group">
              <label htmlFor="password">Password</label>
              <input
                id="password" type="password"
                value={password} onChange={e => setPassword(e.target.value)}
                placeholder="Enter your password"
                required disabled={loading}
              />
            </div>

            {error && (
              <div className="lp-login__error">
                ⚠️ {error}
                {isSubscriptionError && (
                  <button type="button" className="lp-login__error-renew" onClick={() => navigate('/subscribe')}>
                    Renew Subscription →
                  </button>
                )}
              </div>
            )}

            <button type="submit" className="lp-login__btn-primary" disabled={loading}>
              {loading ? 'Signing in...' : 'Sign In →'}
            </button>
            <button type="button" className="lp-login__btn-ghost" onClick={() => navigate('/')}>
              ← Back to Home
            </button>
          </form>

          <div className="lp-login__footer">
            <span>{navigator.onLine ? '🟢 Online' : '🔴 Offline'}</span>
            <span>v{process.env.REACT_APP_VERSION || '1.0.0'}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;